import { useEffect, useState } from "react";
import { getStudents } from "../services/api";
import { Link } from "react-router-dom";

function List() {
  const [students, setStudents] = useState([]);

  useEffect(() => {
    getStudents()
      .then((data) => setStudents(data))
      .catch((err) => console.log("Error fetching students:", err));
  }, []);

  return (
    <div style={styles.container}>
      <h2 style={{ marginBottom: "20px" }}>Student List</h2>

      {!students || students.length === 0 ? (
        <p>No students found</p>
      ) : (
        students.map((s) => (
          <div key={s.StudentID} style={styles.card}>
            <h3>{s.FullName}</h3>

            <p><strong>ID:</strong> {s.StudentID}</p>
            <p><strong>Course:</strong> {s.Course}</p>

            <Link to={`/dashboard/details/${s.StudentID}`}>
  <button style={styles.button}>View Details</button>
</Link>
          </div>
        ))
      )}
    </div>
  );
}

const styles = {
  container: {
    padding: "20px",
  },

  card: {
    border: "1px solid #ccc",
    padding: "15px",
    marginBottom: "10px",
    borderRadius: "8px",
    backgroundColor: "white",
  },

  button: {
    marginTop: "10px",
    padding: "6px 12px",
    border: "1px solid black",
    background: "white",
    cursor: "pointer",
    borderRadius: "5px",
  },
};

export default List;